<template>
  <div class="local-body">
    <div class="bg-bottom-img">
      <div class="d-flex justify-space-between">
        <div>
          <img
            class="v-img__img v-img__img--contain"
            src="data:image/png;base64,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"
            style=""
          />
        </div>
        <div style="position: absolute; bottom: 20px; right: 10px">
          <!-- <video width="300" autoplay loop>
            <source src="@/assets/login/login_video.mp4" type="video/mp4" />
          </video> -->
          <img
            width="300"
            class="v-img__img v-img__img--contain"
            src="@/assets/login/login_video_original.png"
            style=""
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-center align-center" style="height: 70%; z-index: 99; position: relative">
      <div class="login-dialog elevation-2 pt-4 pb-4 pl-10 pr-10 flex-column">
        <!-- title -->
        <div class="d-flex justify-center align-center">
          <div class="pr-1">
            <img src="@/assets/login/icon.webp" width="32" height="32" />
          </div>
          <h1>{{ $t("brand.name") }}</h1>
        </div>

        <!-- 로그인 대상 분기: 스트리머 | 팬 -->
        <v-tabs v-model="loginTab" grow height="42" class="mt-2 mb-3">
          <v-tab>{{ $t("login.tabStreamer") }}</v-tab>
          <v-tab>{{ $t("login.tabFan") }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="loginTab">
          <!-- 스트리머 로그인 (기존 Discord/이메일) -->
          <v-tab-item>
            <h4>{{ $t("login.welcome") }}</h4>
            <p>{{ $t("login.subtitle") }}</p>
            <!-- Discord ↔ 이메일 폼 전환 (한 번에 하나만 표시) -->
            <v-fade-transition mode="out-in">
              <!-- Discord 로그인 (기본, 공식 Blurple 스타일) -->
              <v-btn
                v-if="!showEmailLogin"
                key="discord"
                :loading="isDiscordLoading"
                @click="onClickDiscordLogin"
                block
                large
                depressed
                class="discord-btn mt-2"
              >
                <svg
                  class="discord-logo"
                  viewBox="0 0 127.14 96.36"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    fill="#ffffff"
                    d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z"
                  />
                </svg>
                <span>{{ $t("login.discord") }}</span>
              </v-btn>

              <!-- 이메일/비밀번호 폼 (위 링크로 토글) -->
              <div v-else key="email">
                <v-form v-model="valid">
                  <v-text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    placeholder="Email"
                    outlined
                    hide-details
                    dense
                  ></v-text-field>
                  <v-text-field
                    class="mt-2 input-group--focused"
                    v-model="password"
                    v-on:keyup.enter="onClickLogin"
                    placeholder="Password"
                    dense
                    hide-details
                    outlined
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-form>
                <div style="min-height: 18px">
                  <p v-if="isShowInvalidEmail" class="alert">{{ errorMessage }}</p>
                </div>
                <v-btn :loading="isLoginLoading" @click="onClickLogin" color="primary" block class="mt-2">{{
                  $t("login.submit")
                }}</v-btn>
              </div>
            </v-fade-transition>

            <!-- 토글 링크: 현재 모드의 반대편으로 전환 -->
            <div class="d-flex justify-center pt-4 pb-1">
              <a @click="showEmailLogin = !showEmailLogin" class="email-login-link">
                {{ showEmailLogin ? $t("login.discord") : $t("login.email") }}
              </a>
            </div>
          </v-tab-item>

          <!-- 팬 로그인 (디스코드) -->
          <v-tab-item>
            <h4>{{ $t("login.fanWelcome") }}</h4>
            <p>{{ $t("login.fanSubtitle") }}</p>
            <v-btn
              :loading="isDiscordLoading"
              @click="onClickDiscordLogin"
              block
              large
              depressed
              class="discord-btn mt-2"
            >
              <span>{{ $t("login.discord") }}</span>
            </v-btn>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <!-- 하단 오버레이: 사업자 정보 푸터 -->
    <TheFooter class="login-footer-overlay" />
  </div>
</template>

<script>
import SlackWebhook from "@/domain/slack/SlackWebhook";
import SupabaseApi from "@/api/SupabaseApi";
import { supabase } from "@/utils/supabase";
import { setLocale } from "@/plugins/i18n";
import TheFooter from "@/components/TheFooter.vue";

export default {
  components: { TheFooter },
  created() {
    // executeIfLocal(() => {
    //   this.email = "dhdud1002@gmail.com";
    //   this.email = "sample@virtupet.co";
    //   this.onClickLogin();
    // });
  },
  mounted() {},
  data() {
    return {
      loginTab: 0, // 0=스트리머, 1=팬
      show2: false,
      showEmailLogin: false,
      isDiscordLoading: false,
      isLoginLoading: false,
      isShowInvalidEmail: false,
      valid: false,
      email: null,
      password: null,
      invaliShowDelayFunction: () => {},
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },

  methods: {
    async onClickDiscordLogin() {
      try {
        this.isDiscordLoading = true;
        // 로그인 의도(스트리머/팬)를 OAuth 왕복 뒤 App.vue가 읽어 프로비저닝·라우팅. (redirectTo는 트리거가 못 봄)
        localStorage.setItem("auth/role", this.loginTab === 1 ? "fan" : "streamer");
        // Redirect to Discord; on return App.vue routes by registration status.
        const { error } = await supabase.auth.signInWithOAuth({
          provider: "discord",
          // history 모드: 복귀를 항상 루트로 고정 → ?code= 가 서브패스(/login?code=)로 붙는 것을 방지
          options: { redirectTo: window.location.origin + "/" },
        });
        if (error) throw error;
      } catch (error) {
        this.isDiscordLoading = false;
        this.isShowInvalidEmail = true;
        this.errorMessage = this.$t("login.errDiscord");
        console.error(error);
      }
    },
    // unnecessary code. png 태그로 변경
    _playVideo() {
      const video = this.$el.querySelector("video");
      video.muted = true;
      video.play();
    },
    _whenLoginFailed() {},
    async onClickLogin() {
      try {
        localStorage.setItem("auth/role", "streamer"); // 이메일 로그인 = 스트리머 (활성 역할 갱신)
        clearTimeout(this.invaliShowDelayFunction);
        this.isLoginLoading = true;
        this.isShowInvalidEmail = false;

        this.show2 = false;
        const delay = async (millis) => new Promise((resolve) => setTimeout(resolve, millis));
        await delay(300);

        // 세션 스토리지에 email 주소 기억
        // const user = await AuthFacade.emailOnlyLogin(this.email);
        // Supabase Auth verifies the password (bcrypt). null → invalid credentials.
        const user = await SupabaseApi.UserAccount.login(this.email, this.password);
        if (!user) throw new Error("E_NOT_FOUND");

        // AFTER LOGIN
        const { name } = await SupabaseApi.fetchMyProfile();
        this.$store.commit("__setUserName", name);

        // 계정에 저장된 UI 언어/국가 적용 (localStorage 대체)
        this.$store.commit("__setUserCountryCode", user.countryCode || null);
        if (user.locale) {
          setLocale(user.locale);
          this.$vuetify.lang.current = user.locale;
        }

        SlackWebhook.setUser(user.name || user.streamerAliasId);
        await SlackWebhook.send("로그인 했습니다");

        // 온보딩 미완료(펫 없음 등) → 사용자설정으로. /home 하이드레이트는 건너뜀(App.vue와 동일 분기).
        const isComplete = await SupabaseApi.UserAccountOnboarding.fetchIsComplete();
        if (!isComplete) {
          this.isLoginLoading = false;
          return this.$router.push("/user/new");
        }

        // 하이드레이트는 best-effort: 펫이 없거나 일부 쿼리 실패가 로그인을 막지 않도록 보호
        try {
          const profile = await SupabaseApi.PetProfile.fetchProfile();
          if (profile) this.$store.commit("__setVirtupetName", profile.name);
          const license = await SupabaseApi.BillingPurchase.fetchLicense();
          this.$store.commit("__setExpiredAt", license.expiredAt);
        } catch (e) {
          console.error("onClickLogin: hydrate failed (non-fatal)", e);
        }

        this.isLoginLoading = false;

        this.$router.push("/home");
      } catch (error) {
        this.isShowInvalidEmail = true;
        this.invaliShowDelayFunction = setTimeout(() => (this.isShowInvalidEmail = false), 2000);

        this.errorMessage = (() => {
          if (error.message === "E_EXPIRED") return this.$t("login.errExpired");
          else if (error.message === "E_NOT_FOUND") return this.$t("login.errNotFound");
          else return this.$t("login.errUnknown");
        })();

        this.isLoginLoading = false;

        // failed to login. 일단 error로 처리한다
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.local-body {
  width: 100vw;
  height: 100%;
  background-color: #f4f5fa;
}

/* 하단 오버레이 푸터: bg 이미지 위에 올림 */
.login-footer-overlay {
  position: absolute;
  bottom: 12px;
  left: 0;
  width: 100vw;
  z-index: 100;
  padding: 8px 16px;
  pointer-events: none;
}

.login-dialog {
  background-color: white;
  width: 480px;
  border-radius: 6px;
}

.bg-bottom-img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 200px;
  background-image: url("@/assets/login/bg.png");
  background-size: 100% 100%;
}

p.alert {
  margin: 0px;
  padding: 0px;
  color: rgb(255, 66, 66);
  font-size: 12px;
  animation: slideDown 0.3s ease-in-out;
}

/* Discord 공식 브랜드 버튼 (Blurple #5865F2, 흰 로고) */
.discord-btn {
  background-color: #5865f2 !important;
  color: #ffffff !important;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 600;
  border-radius: 6px;
}
.discord-btn:hover {
  background-color: #4752c4 !important; /* hover: darker blurple */
}
.discord-logo {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

/* 이메일 로그인 링크 (작게, 하이퍼링크 스타일) */
.email-login-link {
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  color: #888;
}
.email-login-link:hover {
  color: #555;
}

/* 팬 탭 안내 문구 (준비 중) */
.fan-hint {
  font-size: 12px;
  color: #999;
}

@keyframes slideDown {
  from {
    transform: translateY(-20%); /* Start above the top */
    opacity: 0;
  }
  to {
    transform: translateY(0); /* End at its original position */
    opacity: 1;
  }
}
</style>
